import { HashRouter, Routes, Route } from 'react-router'

import { DataProvider } from 'data/data.js';

import PasswordGate from 'components/PasswordGate.js';

import TopNav from './components/TopNav.js'
import Footer from './components/Footer.js';

import Home from './pages/Home.js';
import WhyThisMatters from './pages/WhyThisMatters.js';
import ProjectBackground from './pages/ProjectBackground.js';
import Document from './pages/Document.js';
import AboutData from './pages/AboutData.js';
import PortalInfo from './pages/PortalInfo.js';
import Portal from './pages/Portal.js';
import EPARegions from './pages/EPARegions.js';
import Uses from './pages/Uses.js';
import Collaborators from './pages/Collaborators.js';
import Contact from './pages/Contact.js';
import CurationNotes from 'pages/CurationNotes.js';

function App() {

        return (
	<div className="App">
		<PasswordGate>
			<DataProvider>
				<HashRouter>
					<TopNav />
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/portal" element={<Portal />} />
						<Route path="/epa-regions" element={<EPARegions />} />
						<Route path="/why-this-matters" element={<WhyThisMatters />} />
						<Route path="/project-background" element={<ProjectBackground />} />
						<Route path="/about-data" element={<AboutData />} />
						<Route path="/portal-info" element={<PortalInfo />} />
						<Route path="/uses" element={<Uses />} />
						<Route path="/collaborators" element={<Collaborators />} />
						<Route path="/contact" element={<Contact />} />
						<Route path="/document" element={<Document />} />
						<Route path="/curation-notes" element={<CurationNotes />} />
					</Routes>
				</HashRouter>
				<Footer />
			</DataProvider>
		</PasswordGate>
	</div>
        );
}

export default App;
